import { queueFont } from "../queueFont";

type InvalidCustomRoomsLinkProps = {
  onChooseRooms: () => void;
};

export function InvalidCustomRoomsLink({ onChooseRooms }: InvalidCustomRoomsLinkProps) {
  return (
    <div
      className={`${queueFont} flex min-h-screen flex-col items-center justify-center gap-4 bg-white p-6 text-center text-[#334155]`}
    >
      <p className="m-0 max-w-[420px] text-lg">
        This link does not match any rooms on this board. Open the room picker and build a new link.
      </p>
      <button
        type="button"
        onClick={onChooseRooms}
        className={`${queueFont} cursor-pointer rounded-[10px] border-0 bg-[#0b3a66] px-5 py-3 text-base font-bold text-white`}
      >
        Choose rooms
      </button>
    </div>
  );
}
